import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoalibaugcabs() {



const cardData = {
  keyword: "Pune to Alibag Cabs",
  heading: "Lotus Cab: Pune to Alibag Cabs",

  headingDescription:
    "Lotus Cab offers reliable and affordable Pune to Alibag cab services for comfortable coastal travel from Pune to the beautiful beaches of Alibag. Located approximately 140–160 km from Pune, Alibag is a popular weekend getaway known for its clean beaches, forts, and scenic sea views. Whether you are planning a one-way drop, round-trip beach vacation, same-day return journey, or group coastal tour, we provide flexible travel packages with transparent per kilometer pricing. Our AC sedans and spacious SUVs are well-maintained, sanitized, and driven by experienced chauffeurs familiar with Konkan highways and coastal routes. Ideal for family trips, corporate outings, picnic plans, and weekend vacations, Lotus Cab ensures smooth highway travel and punctual pickup across Pune. With easy online booking and 24/7 customer support, we make your Pune to Alibag journey safe, comfortable, and stress-free.",

  top: "Top Places to Visit in Alibag with Lotus Cab",

  topPlaces: [
    {
      title: "Alibag Beach",
      description:
        "Alibag Beach is the most popular attraction known for its peaceful shoreline and beautiful sunset views. Families and couples frequently book Pune to Alibag round trip taxis for weekend relaxation. The beach offers water activities and horse rides during peak season. Lotus Cab ensures comfortable AC travel so you reach refreshed and ready to explore."
    },
    {
      title: "Kolaba Fort",
      description:
        "Kolaba Fort is a historic sea fort accessible during low tide and offers a unique coastal heritage experience. Travelers often combine beach visits with fort exploration in their day trip itinerary. Comfortable sedan and SUV options make the journey smooth and relaxing."
    },
    {
      title: "Nagaon Beach",
      description:
        "Nagaon Beach is known for water sports and clean surroundings. It is ideal for group tours and picnic trips from Pune. Spacious SUV cabs are perfect for carrying luggage and beach gear."
    },
    {
      title: "Kashid Beach",
      description:
        "Kashid Beach offers clear blue water and soft sand, making it a favorite weekend getaway spot. Round-trip taxi booking allows flexible return timing for relaxed beach enjoyment."
    },
    {
      title: "Murud-Janjira Fort",
      description:
        "Murud-Janjira Fort is a magnificent sea fort located near Alibag. Many tourists book extended coastal tours including Murud. Lotus Cab provides safe long-distance coastal travel."
    },
    {
      title: "Kihim Beach",
      description:
        "Kihim Beach is known for peaceful surroundings and lush greenery. It is perfect for couples and family relaxation trips."
    },
    {
      title: "Varsoli Beach",
      description:
        "Varsoli Beach is less crowded and ideal for picnic groups. Chauffeur-driven cabs ensure stress-free travel experience."
    },
    {
      title: "Revdanda Fort",
      description:
        "Revdanda Fort adds historical charm to your Alibag trip. It is suitable for travelers interested in heritage exploration along with beach visits."
    }
  ],

  services: [
    {
      name: "Pune to Alibag Cabs",
      description:
        "Lotus Cab provides reliable Pune to Alibag cab services with transparent per kilometer pricing and flexible travel options. Our vehicles are fully air-conditioned and suitable for long-distance coastal travel. Ideal for families, corporate groups, and weekend travelers. Professional drivers ensure safe highway and ghat-road navigation. One-way, round-trip, and multi-day travel packages available."
    },
    {
      name: "Pune to Alibag One Way Cab",
      description:
        "Affordable one-way drop taxi service from Pune to Alibag where you pay only for single-side travel. Transparent billing and punctual pickup across Pune."
    },
    {
      name: "Pune to Alibag Round Trip Taxi",
      description:
        "Convenient round-trip cab packages with flexible return timing ideal for weekend beach trips and family vacations."
    },
    {
      name: "SUV Cab Pune to Alibag",
      description:
        "Spacious SUV taxi suitable for group tours and coastal travel with luggage support and comfortable seating."
    },
    {
      name: "Luxury Cab Pune to Alibag",
      description:
        "Premium luxury cab options for comfortable and stylish coastal travel experience."
    },
    {
      name: "Same Day Return Cab Pune to Alibag",
      description:
        "Same-day return taxi option ideal for short beach visits and quick corporate outings."
    },
    {
      name: "Online Booking Pune to Alibag",
      description:
        "Easy online booking with instant confirmation and 24/7 travel support."
    },
    {
      name: "Corporate Cab Pune to Alibag",
      description:
        "Professional cab service for corporate beach outings, team events, and business travel."
    }
  ],

  tableData: [
    ["Pune to Alibag Cabs", "Pune to Alibag One Way Cab"],
    ["Pune to Alibag Round Trip Taxi", "Affordable Cab Pune to Alibag"],
    ["Luxury Cab Pune to Alibag", "SUV Cab Pune to Alibag"],
    ["Sedan Taxi Pune to Alibag", "Family Trip Cab Pune to Alibag"],
    ["Corporate Cab Pune to Alibag", "Weekend Trip Taxi Pune to Alibag"],
    ["AC Cab Pune to Alibag", "Online Booking Pune to Alibag"],
    ["Best Outstation Cab Pune to Alibag", "Per Km Rate Pune to Alibag"],
    ["Same Day Return Cab Pune to Alibag", "Group Tour Cab Pune to Alibag"],
    ["Picnic Cab Pune to Alibag", "Outstation Taxi Service Pune to Alibag"],
    ["Chauffeur Driven Cab Pune to Alibag", "Budget Luxury Cab Pune to Alibag"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Transparent Per Km Pricing",
      WhyChoosedescription:
        "Clear fare structure with no hidden charges ensures budget-friendly coastal travel."
    },
    {
      WhyChooseheading: "Experienced Coastal Route Drivers",
      WhyChoosedescription:
        "Professional chauffeurs experienced in Konkan and coastal highways."
    },
    {
      WhyChooseheading: "Comfortable AC Vehicles",
      WhyChoosedescription:
        "Fully air-conditioned sedan and SUV options for relaxed travel."
    },
    {
      WhyChooseheading: "Flexible Travel Options",
      WhyChoosedescription:
        "One-way, round-trip, same-day return, and multi-day packages available."
    },
    {
      WhyChooseheading: "Ideal for Beach & Picnic Trips",
      WhyChoosedescription:
        "Perfect taxi service for weekend beach vacations and family outings."
    },
    {
      WhyChooseheading: "Doorstep Pickup Across Pune",
      WhyChoosedescription:
        "Convenient pickup from home, hotel, or airport location."
    },
    {
      WhyChooseheading: "Luxury & SUV Options Available",
      WhyChoosedescription:
        "Premium and spacious vehicle options for group travel."
    },
    {
      WhyChooseheading: "24/7 Customer Support",
      WhyChoosedescription:
        "Round-the-clock assistance for booking and travel coordination."
    }
  ]
};

const faqData = [
  { question: "What is the distance from Pune to Alibag?", answer: "Alibag is approximately 140–160 km from Pune and takes around 4–5 hours by road." },
  { question: "Is one-way cab available?", answer: "Yes, affordable one-way drop taxi service is available." },
  { question: "Are SUV options available?", answer: "Yes, spacious SUV taxis are available for family and group travel." },
  { question: "Is same-day return possible?", answer: "Yes, same-day return cab service is available." },
  { question: "Is fare calculated per km?", answer: "Yes, fare is calculated on per kilometer basis with transparent billing." },
  { question: "Is AC taxi provided?", answer: "Yes, fully air-conditioned vehicles are provided." },
  { question: "Is online booking available?", answer: "Yes, instant online booking with confirmation is available." },
  { question: "Is corporate booking allowed?", answer: "Yes, corporate outstation taxi packages are available." },
  { question: "Are drivers experienced in coastal routes?", answer: "Yes, trained drivers familiar with Konkan highways." },
  { question: "Is 24/7 support available?", answer: "Yes, round-the-clock customer assistance is provided." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Sharma",
    feedback:
      "Booked Pune to Alibag cab for weekend trip. Very smooth ride and transparent pricing. Highly recommended.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Desai",
    feedback:
      "SUV cab was spacious and comfortable for our family beach trip. Professional driver and punctual service.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Reliable cab service for corporate outing to Alibag. Good vehicle condition and clear fare structure.",
    rating: 5
  }
];

















































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Alibag Cabs",
  "image": "https://lotuscab.com/assets/images/pune-to-alibag-cabs.jpg", 
  "description": "Lotus Cab offers reliable taxi services from Pune to Alibag for one-way, round-trip, weekend trips, family outings, corporate travel, and group tours. Options include luxury, SUV, AC, and sedan cabs with chauffeur service, affordable per km rates, same-day return, and easy online booking for safe and comfortable travel.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3400"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3899",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-alibag-cabs"
  }
};









  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Pune to Alibag Cabs | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book taxi from Pune to Alibag with Lotus Cab. One-way, round-trip, weekend, family & corporate trips. Luxury, SUV & AC cabs with chauffeur service. Affordable per km rates. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Alibag Cabs, Pune to Alibag One Way Cab, Pune to Alibag Round Trip Taxi, Affordable Cab Pune to Alibag, Luxury Cab Pune to Alibag, SUV Cab Pune to Alibag, Sedan Taxi Pune to Alibag, Family Trip Cab Pune to Alibag, Corporate Cab Pune to Alibag, Weekend Trip Taxi Pune to Alibag, AC Cab Pune to Alibag, Online Booking Pune to Alibag, Best Outstation Cab Pune to Alibag, Per Km Rate Pune to Alibag, Same Day Return Cab Pune to Alibag, Group Tour Cab Pune to Alibag, Picnic Cab Pune to Alibag, Outstation Taxi Service Pune to Alibag, Chauffeur Driven Cab Pune to Alibag, Budget Luxury Cab Pune to Alibag" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/48.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoalibaugcabs;